// Homepage Layout Parser
// Parses <hr> elements in page content to create dynamic grid layouts
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".home-narrative");
  if (!container) return;

  const nodes = Array.from(container.childNodes);
  const rows = [];

  let currentRow = [];
  let currentColumn = [];

  const flushColumn = () => {
    if (currentColumn.length) {
      currentRow.push(currentColumn);
      currentColumn = [];
    }
  };

  const flushRow = () => {
    flushColumn();
    if (currentRow.length) {
      rows.push({ type: "row", columns: currentRow });
      currentRow = [];
    }
  };

  // First pass: build layout model and clone nodes
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];

    if (node.nodeName === "HR") {
      let count = 1;
      while (nodes[i + count] && nodes[i + count].nodeName === "HR") {
        count++;
      }

      if (count === 1) {
        // Column break
        flushColumn();
      } else if (count === 2) {
        // Row break
        flushRow();
      } else if (count >= 3) {
        // Row break + Case Studies
        flushRow();
        rows.push({ type: "case-studies" });
      }

      i += count - 1;
    } else {
      // Clone node before storing (since we'll clear container later)
      currentColumn.push(node.cloneNode(true));
    }
  }

  flushRow();
  
  // Clear original content
  container.innerHTML = "";

  // Render rows
  let rowIndex = 0;
  rows.forEach(row => {
    if (row.type === "case-studies") {
      const cs = document.createElement("section");
      cs.className = "home-case-studies";
      const template = document.querySelector("#case-studies-template");
      if (template) {
        // Use template content if available, fallback to innerHTML
        if (template.content) {
          cs.appendChild(template.content.cloneNode(true));
        } else {
          cs.innerHTML = template.innerHTML;
        }
      }
      container.appendChild(cs);
    } else {
      const rowEl = document.createElement("section");
      rowEl.className = `home-row home-row-${rowIndex}`;
      rowEl.style.setProperty("--cols", row.columns.length);

      row.columns.forEach((colNodes, colIndex) => {
        const col = document.createElement("div");
        // Add position-based classes
        const isLeft = colIndex === 0;
        const isRight = colIndex === row.columns.length - 1;
        const positionClass = isLeft ? "home-column-left" : (isRight ? "home-column-right" : "home-column-center");
        col.className = `home-column ${positionClass} home-row-${rowIndex}-col-${colIndex}`;
        colNodes.forEach(n => {
          col.appendChild(n);
        });
        rowEl.appendChild(col);
      });

      container.appendChild(rowEl);
      rowIndex++;
    }
  });
});
